/** When your routing table is too long, you can split it into small modules**/


export default [{
  path: '/marital-request',
  name: 'maritalRequest',
  component: () => import('@/views/marital/Request'),
},
{
  path: '/marital-history',
  name: 'maritalHistory',
  component: () => import('@/views/marital/Index'),
}
]

